import WalletConnect from './walletConnect/walletConnect.js';
import WalletConnectV2 from './walletConnect/walletConnectV2.js';

const getWalletConnectConnector = ({ evmNetworks, isWalletConnectV2Enabled, }) => isWalletConnectV2Enabled
    ? new WalletConnectV2({
        evmNetworks,
        walletName: 'WalletConnect',
    })
    : new WalletConnect({
        evmNetworks,
        walletName: 'WalletConnect',
    });

export { getWalletConnectConnector };
